<template lang="pug">
v-combobox.array-field(
  @input="$emit('input', $event)",
  hide-selected,
  deletable-chips,
  multiple,
  small-chips,
  v-bind="{ value, label, errorMessages }",
)
  template(v-slot:no-data)
    v-list-item
      v-list-item-content
        v-list-item-title(v-html="controlMsg")
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
    items: {
      type: Array,
      default: () => ([]),
    },
    label: {
      type: String,
    },
    errorMessages: null,
  },
  data: () => ({
    search: null,
    controlMsg: 'Press <kbd>Enter</kbd> to create a new entry.',
  }),
}
</script>
